module.exports = __webpack_public_path__ + "static/calculator-8bc4078ef0cf1fa9ba5490096f52ddf9.png";